import React, { useState, useEffect } from "react";
import Select, { components } from 'react-select';
import { useForm } from 'react-hook-form';
import MaterialTable from "material-table";

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    Spinner
} from "reactstrap";


// style
import "../../../assets/css/loading.css";

// services
import { api_GET, api_POST, api_PUT } from "../../../services/api_service";
import { showMessage } from "../../../services/message";
import { table_translate, table_style } from "../../../constants/MaterialTable";

export default function IndiceAtendimentoForm({ handleReturn, id }) {

    const { register, setValue, errors, clearErrors, getValues } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [indiceAtendimento, setIndiceAtendimento] = useState(null);

    const options_Cor = [
        { value: '#2980b9', label: 'Azul' },
        { value: '#e74c3c', label: 'Vermelho' },
        { value: '#f1c40f', label: 'Amarelo' },
        { value: '#2ecc71', label: 'Verde' },
    ];

    // Modalidade
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadesColeta, setModalidadesColeta] = useState([]);
    const loadOptionsModalidadesColeta = () => {
        api_GET(`modalidadeColeta`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            } else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }

    const handleModalidadesColeta = (value) => {
        setModalidadesColeta(value);
    }

    const [regra, setRegra] = useState("É maior que");
    const handleRegra = (value) => {
        setRegra(value);
        clearErrors("regra");
    }

    const [cor, setCor] = useState("#2980b9");
    const handleCor = (value) => {
        setCor(value);
        clearErrors("cor");
    }

    const loadIndiceQualidade = () => {
        api_GET(`IndiceAtendimento/GetItem/${id}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            } else {
                setModalidadesColeta(result.data.configuracaoIndiceAtendimentoModalidades?.map(({ modalidadeColeta }) => modalidadeColeta))
                result.data.configuracaoIndiceAtendimentoCondicoes = result.data.configuracaoIndiceAtendimentoCondicoes?.map(condicao => {
                    condicao.numeroPercentual = `${new Intl.NumberFormat('pt-BR').format(condicao.percentualMinimo)} e ${new Intl.NumberFormat('pt-BR').format(condicao.percentualMaximo)}`;
                    return condicao;
                })

                setListaRegraCondicoes(result.data.configuracaoIndiceAtendimentoCondicoes)
                setIndiceAtendimento(result.data);
            }
        });
    }

    useEffect(() => {
        loadOptionsModalidadesColeta();
        if (id != null)
            loadIndiceQualidade()
    }, []);


    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px',
            // add any other styles you need for options
        }),
        singleValue: (provided, state) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }),
    };

    const columnsProp = [
        { title: 'Condição', field: 'condicao' },
        { title: 'Pontuação', field: 'pontuacao' },
        { title: 'Número de Percentual (%)', field: 'numeroPercentual' },
        {
            title: 'Cor', field: 'cor', render: (rowData) => rowData && (<div className="d-flex align-items-center justify-content-evenly">
                <div style={{ background: rowData.cor, width: '16px', height: '16px', marginRight: '8px' }}></div>
                <div>{options_Cor.filter(x => x.value == rowData.cor)[0].label}</div>
            </div>)
        },
    ]

    const [listaRegraCondicoes, setListaRegraCondicoes] = useState([]);

    const handleAdicionarConfiguracaoIndiceQualidade = () => {
        let data = getValues();

        if (data.condicao == "") {
            showMessage("Aviso", "Por favor, Preencha o campo de condição!", "warning", null);
            return;
        }

        if (data.pontuacao == "") {
            showMessage("Aviso", "Por favor, Preencha o campo de pontuação!", "warning", null);
            return;
        }

        if (data.percentualMinimo == "" || !data.percentualMinimo) {
            showMessage("Aviso", "Por favor, Preencha o primeiro campo de pontuação!", "warning", null);
            return;
        }

        if (data.percentualMaximo == "" || !data.percentualMaximo) {
            showMessage("Aviso", "Por favor, Preencha o segundo campo de pontuação!", "warning", null);
            return;
        }

        if (parseFloat(data.percentualMinimo)  > parseFloat(data.percentualMaximo)) {
            showMessage("Alerta", "Por favor, o valor mínimo não pode ser maior que o máximo.", "warning", null);
            return;
        }

        if (cor == '' || !cor) {
            showMessage("Aviso", "Por favor, Selecione a cor!", "warning", null);
            return;
        }

        const _listaRegraCondicoes = [...listaRegraCondicoes]
        const _newRegraCondicao = {
            configuracaoIndiceAtendimentoCondicaoId: rowDataEdit != null && rowDataEdit?.configuracaoIndiceAtendimentoCondicaoId ? rowDataEdit?.configuracaoIndiceAtendimentoCondicaoId : 0,
            configuracaoIndiceAtendimentoId: indiceAtendimento ? indiceAtendimento.configuracaoIndiceAtendimentoId : 0,
            condicao: data.condicao,
            pontuacao: data.pontuacao,
            cor: cor,
            percentualMinimo: data.percentualMinimo,
            percentualMaximo: data.percentualMaximo,
            numeroPercentual: `${new Intl.NumberFormat('pt-BR').format(data.percentualMinimo)}  e ${new Intl.NumberFormat('pt-BR').format(data.percentualMaximo)}`
        };

        if (rowDataEdit && rowDataEdit.tableData) {
            _listaRegraCondicoes[rowDataEdit.tableData.id] = _newRegraCondicao;
            setListaRegraCondicoes(_listaRegraCondicoes);
        } else {
            setListaRegraCondicoes([..._listaRegraCondicoes, _newRegraCondicao]);
        }


        setValue("condicao", "");
        setValue("pontuacao", "");
        setValue("percentualMaximo", "");
        setValue("percentualMinimo", "");
        setValue("cor", "");
        setCor("#2980b9");
        setRegra("É maior que");
        setRowDataEdit(null);
    }

    const [rowDataEdit, setRowDataEdit] = useState(null);
    const editConfiguracaoIndiceQualidade = (rowData) => {
        setRowDataEdit(rowData);
        setValue("condicao", rowData.condicao);
        setValue("pontuacao", rowData.pontuacao);
        setValue("percentualMinimo", rowData.percentualMinimo ?? "")
        setValue("percentualMaximo", rowData.percentualMaximo)
        setValue("cor", rowData.cor);

        if (!!rowData.cor) {
            setCor(rowData.cor);
        }
    }

    const DeleteConfiguracaoIndiceQualidade = (rowData) => {
        if (rowData && rowData.tableData) {
            let _listaRegraCondicoes = [...listaRegraCondicoes.filter((value, index) => rowData.tableData.id != index)];
            setListaRegraCondicoes(_listaRegraCondicoes);
        }
    }

    const handleOnsubmit = () => {
        if (modalidadesColeta.length == 0) {
            showMessage("Aviso", "Por favor, Adicione pelo menos uma modalidade!", "warning", null);
            return;
        }
        const json = {
            configuracaoIndiceAtendimentoId: indiceAtendimento ? indiceAtendimento.configuracaoIndiceAtendimentoId : 0,
            configuracaoIndiceAtendimentoCondicoes: listaRegraCondicoes,
            configuracaoIndiceAtendimentoModalidades: modalidadesColeta.map(modalidade => ({
                configuracaoIndiceQualidadeModalidadeId: 0,
                modalidadeColetaId: modalidade.modalidadeColetaId,
                configuracaoIndiceAtendimentoId: indiceAtendimento ? indiceAtendimento.configuracaoIndiceAtendimentoId : 0
            }))
        }

        if (indiceAtendimento) {
            setshowLoading(true)
            api_PUT('IndiceAtendimento', json).then(result => {
                setshowLoading(false)
                if (result.status !== 204) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    showMessage("Sucesso", "Sucesso na operação!", 'success', handleReturn);
                }
            });
        } else {
            setshowLoading(true)
            api_POST('IndiceAtendimento', json).then(result => {
                setshowLoading(false)
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    showMessage("Sucesso", "Sucesso na operação!", 'success', handleReturn);
                }
            });
        }
    };


    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Row>
                <Container fluid>
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <strong> Cadastro de Índice de Atendimento</strong>
                        </CardHeader>
                        <CardBody>
                            <form>
                                <Row>
                                    <Col md="12" lg="12" style={{ zIndex: 1000 }}>
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Modalidade de Serviço
                                            </label>
                                            <Select
                                                options={optionsModalidadesColeta}
                                                name="modalidadeColeta"
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                onChange={(value) => { handleModalidadesColeta(value || []) }}
                                                value={optionsModalidadesColeta.filter(({ modalidadeColetaId }) => modalidadesColeta.filter(f => f.modalidadeColetaId == modalidadeColetaId).length > 0)}
                                                placeholder="Selecione"
                                                isMulti="true"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Condicão
                                            </label>
                                            <Input
                                                name="condicao"
                                                placeholder="Condição"
                                                type="text"
                                                maxLength={30}
                                                innerRef={register({ required: true })}
                                            />
                                            {errors.condicao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="2">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Pontuação
                                            </label>
                                            <Input
                                                name="pontuacao"
                                                placeholder="Pontuação"
                                                type="number"
                                                innerRef={register({ required: true })}
                                            />
                                            {errors.pontuacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Número de Percetual (%)
                                            </label>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Input
                                                    name="percentualMinimo"
                                                    type="number"
                                                    innerRef={register({ required: true })}
                                                    className="mr-1"
                                                />
                                                e
                                                <Input
                                                    name="percentualMaximo"
                                                    type="number"
                                                    innerRef={register({ required: false })}
                                                    className="ml-1"
                                                />
                                            </div>
                                            {errors.percentualMaximo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="3" style={{ zIndex: 999 }}>
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Cor
                                            </label>
                                            <Select
                                                options={options_Cor}
                                                name="cor"
                                                onChange={(e) => { handleCor(e.value) }}
                                                value={options_Cor.find(obj => obj.value === cor)}
                                                placeholder="Selecione"
                                                getOptionLabel={({ value, label }) => (
                                                    <>
                                                        {value && (
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div style={{ background: value, width: '16px', height: '16px', marginRight: '8px' }}></div>
                                                                <div>{label}</div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                components={{
                                                    SingleValue: ({ children, ...props }) => (
                                                        <components.SingleValue {...props}>
                                                            {children}
                                                        </components.SingleValue>
                                                    ),
                                                }}
                                                styles={customStyles}
                                                classNamePrefix="react-select"
                                            />
                                            {errors.cor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="4" className="mb-2">
                                        <Button color="info" type="button" onClick={() => handleAdicionarConfiguracaoIndiceQualidade()}>
                                            Adicionar
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" lg="12">
                                        <MaterialTable
                                            title="Lista de Regras e Condições"
                                            columns={columnsProp}
                                            data={listaRegraCondicoes}
                                            isLoading={false}
                                            options={table_style}
                                            actions={[
                                                {
                                                    icon: 'edit',
                                                    tooltip: 'Editar Registro',
                                                    onClick: (event, rowData) => editConfiguracaoIndiceQualidade(rowData)
                                                },
                                                {
                                                    icon: 'delete',
                                                    tooltip: 'Remove Registro',
                                                    onClick: (event, rowData) => DeleteConfiguracaoIndiceQualidade(rowData)
                                                }
                                            ]}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <label className="form-control-label"></label>
                                        <FormGroup>
                                            <Button color="warning" type="button" onClick={() => { handleReturn() }}>
                                                Voltar
                                            </Button>
                                            <Button color="success" type="button" onClick={handleOnsubmit}>
                                                Salvar
                                            </Button>
                                        </FormGroup>
                                    </Col>
                                </Row>

                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </>
    );
}
